module.exports = __webpack_public_path__ + "static/img/banner-csr-09.52b2a16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-09.jpg
// module id = scjU
// module chunks = 99